































import { apiKey } from '@/api/configuration/config'
import { useCreatePayloadCommand, useVerifyCodeCommand } from '@/app/asyncStates/userStates'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import VSpin from './VSpin.vue'

@Component({
  components: {
    VSpin,
  },
})
export default class UserConfirmation extends Vue {
  @Prop({ type: String, required: true }) public payload!: string

  public userCode = ''

  private snackBarIsShowed = false
  private snackBarText = ''

  private invalidLinkMessage = ''

  private notValidCodeText = 'Введён неверный код'

  private manyRequests = 'Повторите попытку позже'

  private createPayloadCommand = useCreatePayloadCommand(apiKey, this.onCreatePayloadError)

  private verifyCommandState = useVerifyCodeCommand(apiKey, this.onVerifyError)

  public get rules() {
    return [(v: string) => !!v || 'Обязательное поле']
  }

  public get canSubmit() {
    return this.rules.every(rule => rule(this.userCode) === true)
  }
  @Watch('payload', { immediate: true })
  public async onPayloadChanged(value: string, oldValue: string) {
    if (!value || value === oldValue) return
    this.invalidLinkMessage = ''
    await this.createPayloadCommand.execute(0, { data: value })
  }

  public onVerifyError(ex: any) {
    if (ex.isAxiosError && ex.response?.status === 429) {
      this.snackBarText = this.manyRequests
      this.snackBarIsShowed = true
    } else {
      this.snackBarText = this.notValidCodeText
      this.snackBarIsShowed = true
    }
  }

  public onCreatePayloadError(ex: any) {
    if (ex.isAxiosError && ex.response?.status === 429) {
      this.invalidLinkMessage = this.manyRequests
    } else if (ex.isAxiosError) {
      this.invalidLinkMessage = ex.response?.data?.detail || 'Неизвестная ошибка'
    } else {
      this.invalidLinkMessage = 'Неизвестная ошибка'
    }
  }

  public async confirm(): Promise<void> {
    if (!this.createPayloadCommand.state.data) {
      console.warn('empty payload')
      return
    }
    const response = await this.verifyCommandState.execute(0, { data: this.createPayloadCommand.state.data, code: this.userCode })
    if (response.returnUri) {
      document.location.assign(response.returnUri)
    }
  }
}
